import { Card } from 'antd';
import Pagination from 'components/Pagination';
import { getTotalPages } from 'components/Pagination/helpers';
import PerPage from 'components/PerPage';
import { I18nContext } from 'contexts/I18n/I18nProvider';
import { paginationAccordionDvr, paginationDVR } from 'core/pagination-optimized/redux/config';
import TableAccordionComponent from 'core/table-accordion/table-accordion-container';
import { useContext, useEffect, useState } from 'react';
import { NpvrFilterAndPagination } from '../../redux/actions';
import mapper, { npvrColumns } from '../../redux/mapper';
import { NpvrItem, NpvrState } from '../../redux/types';
import Header from '../Household/components/Header';
import MultipleSearch from '../MultipleSearch/MultipleSearch';
import { MultipleSearchFilter } from '../MultipleSearch/types';
import Devices from './devices/Devices';
import './npvr-styles.scss';
import Timeline from './timeline/Timeline';

type RecordingsComponentProps = {
  npvr: NpvrState
  hhid: string
  fetch: (hhid: string, filter?: NpvrFilterAndPagination) => void
  clearAccordionTable: (id: string) => void
  getTimelineRecordings: (params: { hhid: string, deviceId: string }) => void
  getAssociatedDevices: (hhid: string) => void
}

export default function RecordingsComponent({ 
  npvr,
  hhid, 
  fetch, 
  getTimelineRecordings, 
  clearAccordionTable, 
  getAssociatedDevices 
}: RecordingsComponentProps) {
  const t = useContext(I18nContext)
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState<MultipleSearchFilter>({} as MultipleSearchFilter)
  const [pageSize, setPageSize] = useState(10)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
    clearAccordionTable('accordion.dvr')
    fetch(hhid, {filter, pagination: {pageNumber: newPage, pageSize}})
  }

  const handleChangePageSize = (newPageSize: number) => {
    setPage(1)
    setPageSize(newPageSize)
    fetch(hhid, {filter, pagination: {pageNumber: 1, pageSize: newPageSize}})
  }

  const onSearch = (filterToSet: MultipleSearchFilter) =>{
    clearAccordionTable('accordion.dvr')
    setFilter(() => filterToSet)
    setPage(1)
    fetch(hhid, {filter: filterToSet, pagination: {pageNumber: 1, pageSize}})
  }

  useEffect(() => {
    if (!npvr.items.length) {
      fetch(hhid, {});
    }

    if (!npvr.timelineItems.length) {
      getTimelineRecordings({ hhid, deviceId: undefined });
    }
    
    if (!npvr.householdDevicesItems.devices.length) {
      getAssociatedDevices(hhid)
    }
  }, [])

  return (
    <div>
      <Header hhid={hhid}/>
      <Devices npvr={npvr} hhid={hhid}/>
      <Timeline npvr={npvr} hhid={hhid}/>
      <Card className='recordings-card'>
        <PerPage pageSize={pageSize} setPageSize={handleChangePageSize}/>
        <MultipleSearch onSearch={onSearch}/>
        <div className='npvr-table-accordion'>
          <TableAccordionComponent
            tableId="dvr"
            tableKeys={['programId', 'program']}
            tableValues="recordings"
            tableColumns={npvrColumns()}
            tablePagination={paginationDVR}
            items={npvr?.items?.map((item: NpvrItem) => mapper(item, t))}
            accordionPagination={paginationAccordionDvr}
            fetch={{
              method: fetch,
              allParams: hhid
            }}
          />
          {npvr.totalElements > 0 &&
            <Pagination page={page} setPage={handleChangePage} totalPages={getTotalPages(npvr.totalElements || 0, pageSize)}/>}
        </div>
      </Card>
    </div>
  );
}
